import React from "react";
import './Industry.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
 

const Industry = ()=> {

    return (
        <>
            <AIheader/>

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Industries</h1>
                                    <p>Rent cars to just about anyone.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
 
            {/* START industryFleetFiveMain */}
            <section className='industryFleetFiveMain industrypageMain'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-rental">
                                    <img className='img-fluid' src="/img/Fleet/car_black.svg" alt="rent id"/>
                                    <h3>Car Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-sharing">
                                    <img className='img-fluid' src="/img/Fleet/refresh_black.svg" alt="rent id"/>
                                    <h3>Car Sharing</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                            <a href="/ride-sharing">
                                <img className='img-fluid' src="/img/Fleet/user_switch_black.svg" alt="rent id"/>
                                <h3>Ride Share</h3>
                            </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/delivery">
                                    <img className='img-fluid' src="/img/Fleet/spoon_black.svg" alt="rent id"/>
                                    <h3>Delivery Drivers</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 2 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/auto-dealerships">
                                    <img className='img-fluid' src="/img/Fleet/car_parking_black.svg" alt="rent id"/>
                                    <h3>Auto Dealerships</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/service-repair">
                                    <img className='img-fluid' src="/img/Fleet/wrench_black.svg" alt="rent id"/>
                                    <h3>Service & Repair</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/vacation-rental">
                                    <img className='img-fluid' src="/img/Fleet/house_black.svg" alt="rent id"/>
                                    <h3>Vacation Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/hotel-resort">
                                    <img className='img-fluid' src="/img/Fleet/hotel_black.svg" alt="rent id"/>
                                    <h3>Hotel & Resort</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 3 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/property-management">
                                    <img className='img-fluid' src="/img/Fleet/building_black.svg" alt="rent id"/>
                                    <h3>Property Mgmt</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/corporate">
                                    <img className='img-fluid' src="/img/Fleet/tie_black.svg" alt="rent id"/>
                                    <h3>Corporate</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/government">
                                    <img className='img-fluid' src="/img/Fleet/pentagon_black.svg" alt="rent id"/>
                                    <h3>Government</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/education">
                                    <img className='img-fluid' src="/img/Fleet/teacher_black.svg" alt="rent id"/>
                                    <h3>Education</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryFleetFiveMain */}
   
            <Footer/>
        </>
    )
}

export default Industry;